import React, { useContext, useState, useEffect, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './styles.module.css';
import withConsoleBase from 'components/utils/ConsoleBase/withConsoleBase';
import { AlertMessagesContext } from 'react-alert-messages';
import { useLocation } from 'react-router-dom';
import {
  Grid,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Select,
  FormControl,
  InputLabel,
  Tooltip,
  CircularProgress,
  Autocomplete,
  InputAdornment,
  IconButton as MuiIconButton,
} from '@mui/material';
import { Button, TextField, Menu, MenuItem, Divider, IconButton, Collapse, Box } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CustomerService from 'services/CustomerService';
import SaleService from 'services/SaleService';
import EstimateService from 'services/EstimateService';
import { TaxHelper } from 'hooks/TaxHelper';
import SearchIcon from '@mui/icons-material/Search';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PrintIcon from '@mui/icons-material/Print';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  SALE_STATUS,
  PAPER_SIZE,
  COUNTRY_CONFIGRATION,
  STORAGE_KEYS,
  BACKEND_URL,
  INVOICE_LAYOUTS,
  PRINT_TYPES,
  SUBSCRIPTION_TYPE,
} from 'const';
import { featureIsExpired } from 'components/utils/FeatureValidityExpire';
import { CartHelper } from 'hooks/CartHelper';
import { InventoryContext } from 'Context/InventoryContext';
import RefundTypePopup from 'components/popups/RefundTypePopup';
import { ShopContext } from 'Context/ShopContext';
import { BillFormatContext } from 'Context/BillFormatContext';
import { TerminalContext } from 'Context/TerminalContext';
import ShopsHelper from 'helpers/ShopsHelper';
import SalesPersonService from 'services/SalesPersonService';
import MessagePopup from 'components/utils/Alert/MessagePopup';
import ShopSettingsService from 'services/ShopSettingsService';
import DateTimeHelpers from 'helpers/DateTimeHelpers';
import SalesUpdateSuccessDialog from 'components/popups/SalesUpdateSuccessDialog';
import NumberField from 'components/library/NumberField';
import BatchSelectionPopup from 'components/popups/BatchSelectionPopup';
import SalesReportsService from 'services/SalesReportsService';
import NewCustomerDialog from 'components/popups/NewCustomerDialog';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useTranslation } from 'react-i18next';
import PrintDocument from 'components/utils/PrintDocument/PrintDocument';
import ItemService from 'services/ItemService';
import { WarehouseContext } from 'Context/WarehouseContext';
import { useMemo } from 'react';

function AddSales() {
  const { t: tCommon } = useTranslation('common');
  const { t: tOperations } = useTranslation('operations');
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const { getBillFormat } = useContext(BillFormatContext);
  const { terminals, selectedTerminal, setSelectedTerminal, getTerminals } = useContext(TerminalContext);
  const { products, getProducts, stockBatches, getStockBatches } = useContext(InventoryContext);
  const { warehouses, getWarehouses, warehouseProducts, getWarehouseProducts } = useContext(WarehouseContext);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');
  const estimateIdParam = queryParams.get('estimate_id');
  const { shop } = useContext(ShopContext);
  const TaxManager = TaxHelper();
  const CartManager = CartHelper();

  const [searchText, setSearchText] = useState('');
  const [saleItems, setSaleItems] = useState([]);
  const [invoiceNoPrefix, setInvoiceNoPrefix] = useState('');
  const [invoiceNoSuffix, setInvoiceNoSuffix] = useState('');
  const [billNo, setBillNo] = useState('');
  const [itemName, setItemName] = useState('');
  const [rate, setRate] = useState('');
  const [stock, setStock] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [tax, setTax] = useState(0);
  const [cess, setCess] = useState(0);
  const [item, setItem] = useState(null);
  const [totalAmount, setTotalAmount] = useState('');
  const [editData, setEditData] = useState({});
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [isShowNewCustomerDialog, setIsShowNewCustomerDialog] = useState(false);
  const [billDate, setBillDate] = useState(new Date());
  const [anchorEl, setAnchorEl] = useState(null);
  const [orders, setOrders] = useState([]);
  const [saleTotals, setSaleTotals] = useState({
    payable: 0,
    tax: 0,
    cess: 0,
  });
  const [discountAppliedOnItems, setDiscountAppliedOnItems] = useState(0);
  const [saleId, setSaleId] = useState(id ?? null);
  const [isShowRefudnTypePopup, setIsShowRefundTypePopup] = useState(false);
  const [salespersons, setSalespersons] = useState([]);
  const [selectedSalespersonId, setSelectedSalespersonId] = useState(null);
  const [selectedWaiter, setSelectedWaiter] = useState(null);
  const [description, setDescription] = useState('');
  const [disabledTerminal, setDisabledTerminal] = useState(null);
  const [paymentModes, setPaymentModes] = useState(null);
  const [customerCreditUsed, setCustomerCreditUsed] = useState(0);
  const [loyaltyPointsUsed, setLoyaltyPointsUsed] = useState(0);
  const [updateSuccessData, setUpdateSuccessData] = useState(null);
  const [remark, setRemark] = useState('');
  const [saleStatus, setSaleStatus] = useState(null);
  const [selectedItemBatches, setSelectedItemBatches] = useState([]);
  const [batchPopupAnchor, setBatchPopupAnchor] = useState(null);
  const [localBatches, setLocalBatches] = useState([]);
  const [editingTableItemIndex, setEditingTableItemIndex] = useState(null);
  const [originalBatchQtys, setOriginalBatchQtys] = useState({});
  const [subItemBatchPopup, setSubItemBatchPopup] = useState({
    open: false,
    anchorEl: null,
    item: null,
    subItem: null,
    saleItemIndex: null,
  });
  const [warehouseId, setWarehouseId] = useState(null);
  const [saleToPrint, setSaleToPrint] = useState(null);
  const [billFormatToPrint, setBillFormatToPrint] = useState(null);
  const [totalsToPrint, setTotalsToPrint] = useState(null);
  const [paperSize, setPaperSize] = useState(PAPER_SIZE.A4);

  const open = Boolean(anchorEl);
  const isMasterDataLoaded = useRef(false);

  const dltItem = (item) => {
    setSaleItems(saleItems.filter(({ item_id, rate }) => item_id !== item.item_id || rate !== item.rate));
  };

  const getOriginalSaleQtys = () => {
    const originalQtys = {};
    if (editData && editData.items) {
      for (const si of editData.items) {
        const itemId = si.item_id || si.item?.id;
        if (itemId) {
          const resolvedItem = (products || []).find((p) => String(p.id) === String(itemId));
          if (resolvedItem?.type === 'COMBO') {
            for (const subItem of (resolvedItem.details?.sub_items || [])) {
              const subId = String(subItem.item_id);
              const subQty = Number(subItem.fraction || 0) * Number(si.quantity || 0);
              originalQtys[subId] = (originalQtys[subId] || 0) + subQty;
            }
          } else {
            const idStr = String(itemId);
            originalQtys[idStr] = (originalQtys[idStr] || 0) + Number(si.quantity || 0);
          }
        }
      }
    }
    return originalQtys;
  };

  const resetItemFields = () => {
    setItemName('');
    setRate('');
    setQuantity('');
    setTax('');
    setDescription('');
    setCess('');
    setTotalAmount('');
    setItem(null);
    setSelectedSalespersonId(null);
    setSelectedItemBatches([]);
    setBatchPopupAnchor(null);
    setStock('');
  };

  const clearSaleHandler = () => {
    setBillDate(new Date());
    setInvoiceNoSuffix(invoiceNoSuffix + 1);
    setBillNo('');
    setSelectedCustomer(null);
    setSelectedWaiter(null);
    resetItemFields();
    setSaleItems([]);
    setEditData({});
    setOriginalBatchQtys({});
    setRemark('');
    setDiscountAppliedOnItems(0);
    setCustomerCreditUsed(0);
    setLoyaltyPointsUsed(0);
    setPaymentModes((prev) => {
      if (prev) {
        return prev.map((pm) => ({ ...pm, amount: 0 }));
      }
      return null;
    });
  };

  const addItem = () => {
    let sub_item = [];
    if (item && item.type === 'COMBO') {
      sub_item = (item.details?.sub_items || []).map((subItem) => {
        const prod = (products || []).find((p) => String(p.id) === String(subItem.item_id));
        const requiredQty = subItem.fraction * quantity;

        let selectedBatches = [];
        if (prod?.is_batch_enabled) {
          // Auto-allocate batches
          const currentWhId = warehouseId === 0 ? null : warehouseId;
          const availableBatches = (stockBatches || [])
            .filter((b) => {
              const isSameItem = String(b.item) === String(subItem.item_id);
              if (!isSameItem) return false;

              if (currentWhId) {
                const bWhId = b.warehouse?.id || b.warehouse || null;
                if (String(bWhId) !== String(currentWhId)) return false;
              }

              // Expiry check: treat 'Z' as local time for accurate comparison
              const expiryDate = b.expiry_date ? new Date(b.expiry_date.replace('Z', '')) : null;
              const isExpired = expiryDate && expiryDate <= new Date();
              return !isExpired;
            })
            .sort((a, b) => {
              if (!a.expiry_date) return 1;
              if (!b.expiry_date) return -1;
              return new Date(a.expiry_date) - new Date(b.expiry_date);
            });

          let remainingToAllocate = requiredQty;
          for (const batch of availableBatches) {
            if (remainingToAllocate <= 0) break;
            const take = Math.min(remainingToAllocate, batch.stock || 0);
            if (take > 0) {
              selectedBatches.push({
                batch_id: batch.id,
                quantity: take,
                batch_no: batch.batch_no || batch.batch_name,
              });
              remainingToAllocate -= take;
            }
          }
        }

        return {
          id: subItem.id, // ID from details
          item_id: subItem.item_id,
          name: subItem.name || prod?.name || '-',
          quantity: requiredQty,
          fraction: subItem.fraction,
          cost: prod?.cost || 0,
          totalCost: requiredQty * (prod?.cost || 0),
          is_batch_enabled: prod?.is_batch_enabled,
          batch_data: selectedBatches,
        };
      });
    }

    const data = {
      item_id: item ? item.id : null,
      rate,
      quantity,
      tax: tax === '' ? 0 : tax ?? 0,
      cess: cess === '' ? 0 : cess ?? 0,
      payable: totalAmount,
      name: item ? itemName : '',
      item,
      description,
      salesperson_id: selectedSalespersonId,
      batch_data: selectedItemBatches,
      sub_item,
    };

    setSaleItems([...saleItems, data]);
    resetItemFields();

    setPaymentModes((prev) => {
      if (!prev || prev.length === 0) return prev;
      const newModes = [...prev];
      newModes[0] = {
        ...newModes[0],
        amount: Number(newModes[0].amount) + Number(data.payable || 0),
      };
      return newModes;
    });
  };

  const getCustomers = async (newCustomer) => {
    const resp = await CustomerService.getCustomers();
    setCustomers(resp);
    if (newCustomer) {
      const found = resp.find((c) => c.id === newCustomer.id);
      if (found) {
        setSelectedCustomer(found);
      } else {
        setSelectedCustomer(newCustomer);
      }
    }
  };

  const getCustomerGroups = async () => {
    try {
      const resp = await CustomerService.getCustomerGroups();
      setCustomerGroups(resp);
    } catch (err) {}
  };

  const getSalespersons = async () => {
    const resp = await SalesPersonService.getSalesPersons();
    setSalespersons(resp);
  };

  const getPaymentModes = async () => {
    const resp = await ShopSettingsService.getPaymentModes();
    if (resp.length > 0) {
      const payments = resp.map((pm) => ({
        mode_id: pm.id,
        name: pm.name,
        amount: 0,
      }));
      setPaymentModes(payments);
    }
  };

  const getNextinvoiceNo = useCallback(
    async (prefix) => {
      setLoadingIndicator(true);
      try {
        const resp = await SaleService.getHighestInvoiceNumber(prefix);
        setInvoiceNoSuffix(resp?.highest_bill_no + 1);
      } catch (error) {
        postAlertMessage({ text: error.message, type: 'failed' });
      }
      setLoadingIndicator(false);
    },
    [postAlertMessage]
  );

  const fetchInitialData = async () => {
     const promises = [
      getCustomers(),
      getSalespersons(),
      getTerminals(),
      getProducts(),
      getPaymentModes(),
      getStockBatches(),
      getCustomerGroups(),
    ];

    if (ShopsHelper.isWarehouseFeatureActive(shop)) {
      promises.push(getWarehouses({ useCache: true }));
      promises.push(getWarehouseProducts({ useCache: true }));
    }

    await Promise.all(promises);
  };

  const getInvalidComboItem = () => {
    if (saleItems.length === 0) return null;

    const invalidItem = saleItems.find(
      (saleItem) =>
        saleItem.item?.type === 'COMBO' &&
        (saleItem.sub_item || []).some((si) => {
          if (!si.is_batch_enabled) return false;

          const totalSelected = (si.batch_data || []).reduce((sum, b) => sum + (b.quantity || 0), 0);
          return Math.abs(si.quantity - totalSelected) >= 0.001;
        })
    );
    return invalidItem;
  };

  const handleCloseRefundTypePopup = () => {
    setIsShowRefundTypePopup(false);
  };

  const openCreateNewCustomerDialog = () => {
    setIsShowNewCustomerDialog(true);
  };

  const closeCreateNewCustomerDialog = () => {
    setIsShowNewCustomerDialog(false);
  };

  const handleSaleEditHandler = (statu = null) => {
    if (editData.customer && editData.customer.id !== selectedCustomer.id) {
      setIsShowRefundTypePopup(true);
      setSaleStatus(statu);
      return;
    }
    handleEditSale(statu);
  };

  const handleEditSale = async (status = null, refundType = null) => {
    setLoadingIndicator(true);
    try {
      if (selectedCustomer && loyaltyPointsUsed > selectedCustomer.points) {
        postAlertMessage({
          text: tOperations('insufficient_loyalty_point'),
          type: 'failed',
        });
        setLoadingIndicator(false);
        return;
      }

      if (selectedCustomer && customerCreditUsed > 0) {
        const maxAvailableCredit = selectedCustomer.balance - selectedCustomer.credit_limit;
        if (customerCreditUsed > maxAvailableCredit) {
          postAlertMessage({
            text: `${tOperations('Credit limit exceeded. Max available credit:')} '${maxAvailableCredit}'`,
            type: 'failed',
          });
          setLoadingIndicator(false);
          return;
        }
      }

      if (saleItems.length === 0) {
        postAlertMessage({
          text: tOperations('add_at_least_one_item'),
          type: 'failed',
        });
        setLoadingIndicator(false);
        return;
      }

      const invalidCombo = getInvalidComboItem();
      if (invalidCombo) {
        postAlertMessage({
          text: `Total batch quantity must match the required quantity for sub items in "${invalidCombo.name}".`,
          type: 'failed',
        });
        setLoadingIndicator(false);
        return;
      }

      if (shop?.stock_availability_check_for_sale) {
        const requiredQtys = {};
        const itemSources = {};

        for (const saleItem of saleItems) {
          if (saleItem.item_id) {
            if (saleItem.item?.type === 'COMBO') {
              for (const subItem of (saleItem.sub_item || [])) {
                const subId = String(subItem.item_id);
                requiredQtys[subId] = (requiredQtys[subId] || 0) + Number(subItem.quantity);
                if (!itemSources[subId]) itemSources[subId] = [];
                const comboLabel = `combo "${saleItem.name || saleItem.item?.name}"`;
                if (!itemSources[subId].includes(comboLabel)) {
                  itemSources[subId].push(comboLabel);
                }
              }
            } else {
              const itemId = String(saleItem.item_id);
              requiredQtys[itemId] = (requiredQtys[itemId] || 0) + Number(saleItem.quantity);
              if (!itemSources[itemId]) itemSources[itemId] = [];
              if (!itemSources[itemId].includes('standalone')) {
                itemSources[itemId].push('standalone');
              }
            }
          }
        }

        const originalQtys = getOriginalSaleQtys();

        for (const [itemId, reqQty] of Object.entries(requiredQtys)) {
          const prodItem = (products || []).find((p) => String(p.id) === itemId);
          if (prodItem) {
            const availableStock = getItemAvailableStock(prodItem);
            const origQty = originalQtys[itemId] || 0;
            const additionalQty = reqQty - origQty;
            if (additionalQty > availableStock) {
              const sourcesList = itemSources[itemId] || [];
              const comboSources = sourcesList.filter((s) => s !== 'standalone');
              let sourceMsg = '';
              if (comboSources.length > 0) {
                sourceMsg = ` (required as sub-item for ${comboSources.join(' and ')})`;
              }
              postAlertMessage({
                text: `Insufficient stock for "${prodItem.name}"${sourceMsg}. Available stock is ${availableStock}, but required total is ${reqQty} (additional required: ${additionalQty}).`,
                type: 'failed',
              });
              setLoadingIndicator(false);
              return;
            }
          }
        }
      }

      const processedSaleItems = saleItems.map((si) => ({ ...si }));

      const data = {
        ...editData,
        time: new Date(billDate),
        payable: saleTotals?.payable,
        tax: saleTotals?.tax,
        cess: saleTotals?.cess,
        customer_id: selectedCustomer ? selectedCustomer.id : null,
        customer: selectedCustomer ? {id: selectedCustomer.id,name: selectedCustomer.name,mobile: selectedCustomer.mobile,} : null,
        bill_no: billNo,
        waiter_id: selectedWaiter?.id || null,
        items: processedSaleItems,
        discount: discountAppliedOnItems,
        refund_type: refundType,
        status,
        remark,
        warehouse_id: warehouseId === 0 ? null : warehouseId,
      };

      const response = await SaleService.updateSale(saleId, data);

      const isPremium = shop?.subscription?.type === SUBSCRIPTION_TYPE.PREMIUM;
      const hasBatchEnabled = saleItems.some(
        (item) =>
          item.item?.is_batch_enabled ||
          (item.item?.type === 'COMBO' && (item.sub_item || []).some((si) => si.is_batch_enabled))
      );
      const isWarehouseEnabled = ShopsHelper.isWarehouseFeatureActive(shop) || !featureIsExpired(shop?.warehouse_validity);

      const promises = [
        getProducts({ useCache: false }),
        getCustomers(),
      ];
      if (isPremium && hasBatchEnabled) {
        promises.push(getStockBatches({ useCache: false }));
      }
      if (isWarehouseEnabled) {
        promises.push(getWarehouseProducts({ useCache: false }));
      }
      await Promise.all(promises);
      setIsShowRefundTypePopup(false);

      const saleToStore = {
        ...data,
        ...(response || {}),
        id: saleId,
        items: processedSaleItems,
        customer: selectedCustomer,
        waiter: selectedWaiter,
        terminal: selectedTerminal,
      };

      setUpdateSuccessData({
        action: 'Update',
        invoiceNo: saleToStore.bill_no,
        sale_id: saleId,
        sale: saleToStore,
      });

      clearSaleHandler();
    } catch (err) {
      postAlertMessage({ text: err.message, type: 'failed' });
    } finally {
      setLoadingIndicator(false);
    }
  };

  const handleAddSale = async (status) => {
    setLoadingIndicator(true);

    try {
      const payable = Number(saleTotals?.payable || 0);

      const conversionRate = Number(shop?.loyalty_point_conversion_rate || 1);
      const loyaltyPointsValue = loyaltyPointsUsed * conversionRate;
      const totalTender =
        (paymentModes || []).reduce((sum, mode) => sum + Number(mode.amount || 0), 0) +
        customerCreditUsed +
        loyaltyPointsValue;

      if (selectedCustomer && loyaltyPointsUsed > selectedCustomer.points) {
        postAlertMessage({
          text: tOperations('insufficient_loyalty_point'),
          type: 'failed',
        });
        setLoadingIndicator(false);
        return;
      }
      if (selectedCustomer && customerCreditUsed > 0) {
        const maxAvailableCredit = selectedCustomer.balance - selectedCustomer.credit_limit;
        if (customerCreditUsed > maxAvailableCredit) {
          postAlertMessage({
            text: `${tOperations('Credit limit exceeded. Max available credit:')} '${maxAvailableCredit}'`,
            type: 'failed',
          });
          setLoadingIndicator(false);
          return;
        }
      }

      if (saleItems.length === 0) {
        postAlertMessage({
          text: tOperations('add_at_least_one_item'),
          type: 'failed',
        });
        setLoadingIndicator(false);
        return;
      }

      if (Math.abs(totalTender - payable) > 0.01) {
        postAlertMessage({
          text: tOperations('The amount paid does not match the total bill. Please check and try again.'),
          type: 'failed',
        });
        setLoadingIndicator(false);
        return;
      }

      if (ShopsHelper.isFreePlan(shop)) {
        const currentMonthStart = DateTimeHelpers.getStartOfMonthInYMD();
        const summary = await SalesReportsService.getSalesSummary({
          from_date: currentMonthStart,
          to_date: DateTimeHelpers.getTodayStrInYMD(),
        });

        if ((summary?.no_of_invoices || 0) >= 600) {
          postAlertMessage({
            text: 'Monthly sales limit reached for Free Plan (max 600 sales).',
            type: 'failed',
          });
          setLoadingIndicator(false);
          return;
        }
      }

      if (totalAmount > 0) {
        postAlertMessage({
          text: 'Please add the pending item to the cart or clear it before saving.',
          type: 'failed',
        });
        setLoadingIndicator(false);
        return;
      }

      const invalidCombo = getInvalidComboItem();
      if (invalidCombo) {
        postAlertMessage({
          text: `Total batch quantity must match the required quantity for sub items in "${invalidCombo.name}".`,
          type: 'failed',
        });
        setLoadingIndicator(false);
        return;
      }

      if (shop?.stock_availability_check_for_sale) {
        const requiredQtys = {};
        const itemSources = {};

        for (const saleItem of saleItems) {
          if (saleItem.item_id) {
            if (saleItem.item?.type === 'COMBO') {
              for (const subItem of (saleItem.sub_item || [])) {
                const subId = String(subItem.item_id);
                requiredQtys[subId] = (requiredQtys[subId] || 0) + Number(subItem.quantity);
                if (!itemSources[subId]) itemSources[subId] = [];
                const comboLabel = `combo "${saleItem.name || saleItem.item?.name}"`;
                if (!itemSources[subId].includes(comboLabel)) {
                  itemSources[subId].push(comboLabel);
                }
              }
            } else {
              const itemId = String(saleItem.item_id);
              requiredQtys[itemId] = (requiredQtys[itemId] || 0) + Number(saleItem.quantity);
              if (!itemSources[itemId]) itemSources[itemId] = [];
              if (!itemSources[itemId].includes('standalone')) {
                itemSources[itemId].push('standalone');
              }
            }
          }
        }

        const originalQtys = getOriginalSaleQtys();

        for (const [itemId, reqQty] of Object.entries(requiredQtys)) {
          const prodItem = (products || []).find((p) => String(p.id) === itemId);
          if (prodItem) {
            const availableStock = getItemAvailableStock(prodItem);
            const origQty = originalQtys[itemId] || 0;
            const additionalQty = reqQty - origQty;
            if (additionalQty > availableStock) {
              const sourcesList = itemSources[itemId] || [];
              const comboSources = sourcesList.filter((s) => s !== 'standalone');
              let sourceMsg = '';
              if (comboSources.length > 0) {
                sourceMsg = ` (required as sub-item for ${comboSources.join(' and ')})`;
              }
              postAlertMessage({
                text: `Insufficient stock for "${prodItem.name}"${sourceMsg}. Available stock is ${availableStock}, but required total is ${reqQty} (additional required: ${additionalQty}).`,
                type: 'failed',
              });
              setLoadingIndicator(false);
              return;
            }
          }
        }
      }

      const processedSaleItems = saleItems.map((si) => ({ ...si }));

      let payment_modes = (paymentModes || []).filter((pm) => Number(pm.amount) !== 0);

      const saleData = {
        ...editData,
        time: DateTimeHelpers.getTimezoneOffsetDate(billDate).toISOString(),
        payable,
        tax: saleTotals?.tax,
        cess: saleTotals?.cess,
        customer_id: selectedCustomer?.id || null,
        waiter: selectedWaiter,
        bill_no: `${invoiceNoPrefix}${invoiceNoSuffix}`,
        bare_bill_no: Number(invoiceNoSuffix),
        payment_modes,
        customer_credit_used: customerCreditUsed,
        loyalty_points_used: loyaltyPointsValue,
        items: processedSaleItems,
        discount: discountAppliedOnItems,
        remark,
        source: 'SANOFT_ADMIN',
        status,
        warehouse_id: warehouseId === 0 ? null : warehouseId,
      };

      const sale = await SaleService.createSale(saleData);
      if (estimateIdParam) {
        try {
          await EstimateService.updateEstimate(estimateIdParam, {
            status: 'converted',
            converted_sale_id: sale.sale_id,
          });
        } catch (error) {
          console.error('Failed to update estimate status:', error);
        }
      }
      const isPremium = shop?.subscription?.type === SUBSCRIPTION_TYPE.PREMIUM;
      const hasBatchEnabled = saleItems.some(
        (item) =>
          item.item?.is_batch_enabled ||
          (item.item?.type === 'COMBO' && (item.sub_item || []).some((si) => si.is_batch_enabled))
      );
      const isWarehouseEnabled = ShopsHelper.isWarehouseFeatureActive(shop) || !featureIsExpired(shop?.warehouse_validity);

      const promises = [
        getProducts({ useCache: false }),
        getCustomers(),
      ];
      if (isPremium && hasBatchEnabled) {
        promises.push(getStockBatches({ useCache: false }));
      }
      if (isWarehouseEnabled) {
        promises.push(getWarehouseProducts({ useCache: false }));
      }
      await Promise.all(promises);

      const saleToStore = {
        ...saleData,
        ...(sale || {}),
        id: sale?.id || sale?.sale_id,
        items: processedSaleItems,
        customer: selectedCustomer,
        waiter: selectedWaiter,
        terminal: selectedTerminal,
      };
      setUpdateSuccessData({
        action: 'Create',
        invoiceNo: saleToStore.bill_no,
        sale_id: saleToStore.id || saleToStore.sale_id,
        sale: saleToStore,
      });
      clearSaleHandler();
    } catch (err) {
      postAlertMessage({ text: err.message, type: 'failed' });
    } finally {
      setLoadingIndicator(false);
    }
  };

  const handleSearchClick = async (event) => {
    if (searchText.length === 0) {
      postAlertMessage({ text: tOperations('Enter search text'), type: 'failed' });
      setAnchorEl(null);
      return;
    }
    setLoadingIndicator(true);
    try {
      const searchAnchor = event.currentTarget;
      const resp = await SaleService.getSales({ search: searchText });
      if (!resp.length) {
        postAlertMessage({ text: tOperations('No sales found'), type: 'failed' });
      } else {
        setAnchorEl(searchAnchor);
        setOrders(resp);
      }
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    }
    setLoadingIndicator(false);
  };

  const handleSearchClose = () => {
    setAnchorEl(null);
  };

  const handleSelectSaleClick = async (sale) => {
    setLoadingIndicator(true);
    try {
      setEditData(sale);
      setBillNo(sale.bill_no);
      setSaleId(sale.id);
      setBillDate(new Date(sale.time));
      setWarehouseId(sale.warehouse || 0);
      const processedItems = sale.items.map((si) => {
        let updatedItem = si?.item;
        if (updatedItem?.id) {
          const invItem = products.find((p) => p.id === updatedItem.id);
          if (invItem) {
            updatedItem = invItem;
          }
        }

        let sub_item = [];
        if (updatedItem?.type === 'COMBO') {
          // Parse sub_item_batch_data from backend
          let savedSubItemBatches = si.sub_item_batch_data || si.config?.sub_item_batch_data || [];
          if (savedSubItemBatches.length === 0) {
            const nestedSubItems = si.sub_item || si.config?.sub_item || [];
            nestedSubItems.forEach((subItemEntry) => {
              if (subItemEntry.batch_data) {
                subItemEntry.batch_data.forEach((b) => {
                  savedSubItemBatches.push({
                    item_id: subItemEntry.item_id,
                    batch_id: b.batch_id,
                    quantity: b.quantity,
                  });
                });
              }
            });
          }

          sub_item = (updatedItem.details?.sub_items || []).map((subItem) => {
            const prod = (products || []).find((p) => String(p.id) === String(subItem.item_id));
            const requiredQty = subItem.fraction * si.quantity;

            // Load selected batches for this subItem from saved data
            const selectedBatches = savedSubItemBatches
              .filter((sb) => String(sb.item_id) === String(subItem.item_id))
              .map((sb) => {
                const batch =
                  (localBatches || []).find((b) => String(b.id) === String(sb.batch_id)) ||
                  (stockBatches || []).find((b) => String(b.id) === String(sb.batch_id));
                return {
                  batch_id: sb.batch_id,
                  quantity: sb.quantity,
                  batch_no: batch?.batch_no || batch?.batch_name || '-',
                };
              });

            return {
              id: subItem.id,
              item_id: subItem.item_id,
              name: subItem.name || prod?.name || '-',
              quantity: requiredQty,
              fraction: subItem.fraction,
              cost: prod?.cost || 0,
              totalCost: requiredQty * (prod?.cost || 0),
              is_batch_enabled: prod?.is_batch_enabled,
              batch_data: selectedBatches,
            };
          });
        }

        return {
          ...si,
          item: updatedItem,
          item_id: updatedItem?.id,
          name: updatedItem?.name,
          batch_data: si.config?.batch_data || si.batch_data || [],
          sub_item,
        };
      });
      setSaleItems(processedItems);
      setDiscountAppliedOnItems(sale?.discount_applied_on_items);
      setSelectedCustomer(sale?.customer);
      setAnchorEl(null);
      setSelectedWaiter(sale?.waiter || null);
      setRemark(sale.remark);

      // Fetch missing batches
      const missingBatchIds = [];
      processedItems.forEach((item) => {
        if (item.batch_data) {
          item.batch_data.forEach((sb) => {
            if (!localBatches.some((lb) => String(lb.id) === String(sb.batch_id))) {
              missingBatchIds.push(sb.batch_id);
            }
          });
        }
        if (item.sub_item) {
          item.sub_item.forEach((si) => {
            if (si.batch_data) {
              si.batch_data.forEach((sb) => {
                if (!localBatches.some((lb) => String(lb.id) === String(sb.batch_id))) {
                  missingBatchIds.push(sb.batch_id);
                }
              });
            }
          });
        }
      });

      if (missingBatchIds.length > 0) {
        try {
          const fetchedBatches = await Promise.all(missingBatchIds.map((id) => ItemService.getStockBatch(id)));
          setLocalBatches((prev) => {
            const existingIds = prev.map((b) => String(b.id));
            const uniqueNew = fetchedBatches.filter((b) => b && !existingIds.includes(String(b.id)));
            return [...prev, ...uniqueNew];
          });
        } catch (err) {
          console.error('Failed to fetch missing batches:', err);
        }
      }

      // Populate originalBatchQtys
      const origQtys = {};
      processedItems.forEach((item) => {
        (item.batch_data || []).forEach((sb) => {
          origQtys[String(sb.batch_id)] = (origQtys[String(sb.batch_id)] || 0) + (Number(sb.quantity) || 0);
        });
        if (item.sub_item) {
          item.sub_item.forEach((si) => {
            (si.batch_data || []).forEach((sb) => {
              origQtys[String(sb.batch_id)] = (origQtys[String(sb.batch_id)] || 0) + (Number(sb.quantity) || 0);
            });
          });
        }
      });
      setOriginalBatchQtys(origQtys);
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    } finally {
      setLoadingIndicator(false);
    }
  };

  useEffect(() => {
    if (ShopsHelper.isWarehouseFeatureActive(shop) && !saleId) {
      if (selectedTerminal?.default_warehouse) {
        setWarehouseId(selectedTerminal.default_warehouse);
      } else if (shop?.config?.default_warehouse) {
        setWarehouseId(shop.config.default_warehouse);
      }
    }
  }, [shop, selectedTerminal, saleId]);

  const getItemAvailableStock = (productItem) => {
    if (!productItem || !productItem.id) return 0;
    const currentWhId = warehouseId === 0 ? null : warehouseId;
    if (currentWhId) {
      const wp = warehouseProducts.find((p) => {
        const bWhId = p.warehouse?.id || p.warehouse || null;
        const bItemId = p.item?.id || p.item || null;
        return String(bWhId) === String(currentWhId) && String(bItemId) === String(productItem.id);
      });
      return wp ? wp.stock : 0;
    }
    return productItem.stock || 0;
  };

  const selectItemHandler = (item) => {
    const initialStock = getItemAvailableStock(item);
    let defaultQty = item.is_batch_enabled ? 0 : 1;
    if (shop?.stock_availability_check_for_sale && item?.type !== 'COMBO') {
      defaultQty = Math.max(0, Math.min(defaultQty, initialStock));
    }

    const selectedItem = { ...item, quantity: defaultQty, rate: TaxManager.getItemUnitRate(item) };
    setItem(selectedItem || '');
    setItemName(item.name || '');

    setStock(initialStock || 0);
    setRate(selectedItem?.rate || 0);
    setQuantity(defaultQty);
    let itemTax = TaxManager.getItemTax(selectedItem);
    let itemCess = TaxManager.getItemCess(selectedItem);
    setTax(itemTax);
    setCess(itemCess);
    setTotalAmount(ShopsHelper.getAmountFormatted(shop, CartManager.getItemAmount(selectedItem) + itemTax + itemCess));
    setSelectedItemBatches([]);
  };

  const handleBatchQuantityChange = (batchId, val) => {
    let qty = Number(val);
    const batch = (localBatches || []).find((b) => b.id === batchId);
    const adjustedStock = (batch?.stock || 0) + (originalBatchQtys[String(batchId)] || 0);
    const allowedQty = Number(adjustedStock.toFixed(3));

    if (batch && qty > allowedQty) {
      qty = allowedQty;
      postAlertMessage({
        text: `${tOperations('Quantity cannot exceed available stock')} (${allowedQty})`,
        type: 'failed',
      });
    }

    const updateBatchList = (prev, bId, bQty) => {
      if (bQty <= 0) {
        return prev.filter((b) => b.batch_id !== bId);
      }
      const existing = prev.find((b) => b.batch_id === bId);
      if (existing) {
        return prev.map((b) => (b.batch_id === bId ? { ...b, quantity: bQty } : b));
      } else {
        return [...prev, { batch_id: bId, quantity: bQty }];
      }
    };

    if (editingTableItemIndex !== null) {
      setSaleItems((prev) =>
        prev.map((si, idx) => {
          if (idx === editingTableItemIndex) {
            const updatedBatches = updateBatchList(si.batch_data || [], batchId, qty);
            const totalQty = updatedBatches.reduce((sum, b) => sum + b.quantity, 0);
            const updatedItem = {
              ...si,
              batch_data: updatedBatches,
              quantity: totalQty,
              tax: si.item?.tax || 0,
              cess: si.item?.cess || 0,
            };
            updatedItem.tax = TaxManager.getItemTax(updatedItem);
            updatedItem.cess = TaxManager.getItemCess(updatedItem);
            updatedItem.payable = CartManager.getItemAmount(updatedItem) + updatedItem.tax + updatedItem.cess;
            return updatedItem;
          }
          return si;
        })
      );
    } else {
      setSelectedItemBatches((prev) => {
        const newBatches = updateBatchList(prev, batchId, qty);
        const totalBatchQty = newBatches.reduce((sum, b) => sum + b.quantity, 0);
        handleChangeQty(totalBatchQty);
        return newBatches;
      });
    }
  };

  const handleOpenSubItemBatchPopup = (event, saleItemIndex, subItem) => {
    const prod = (products || []).find((p) => String(p.id) === String(subItem.item_id));
    setSubItemBatchPopup({
      open: true,
      anchorEl: event.currentTarget,
      item: prod,
      subItem: subItem,
      saleItemIndex: saleItemIndex,
    });
  };

  const handleSubItemBatchChange = (batchId, val) => {
    const { saleItemIndex, subItem } = subItemBatchPopup;
    const qtyValue = parseFloat(val) || 0;

    const batch = (localBatches || []).find((b) => String(b.id) === String(batchId));
    const origQty = originalBatchQtys[String(batchId)] || 0;
    const availableStock = (batch?.stock || 0) + origQty;

    let finalQty = qtyValue;
    if (finalQty > availableStock) {
      postAlertMessage({
        text: `${tOperations('Quantity cannot exceed available stock')} (${availableStock})`,
        type: 'failed',
      });
      finalQty = availableStock;
    }

    setSaleItems((prev) => {
      const next = [...prev];
      const targetSaleItem = { ...next[saleItemIndex] };
      const nextSubItemArray = (targetSaleItem.sub_item || []).map((si) => ({ ...si }));

      const subItemIndex = nextSubItemArray.findIndex((si) => si.item_id === subItem.item_id);
      if (subItemIndex === -1) return prev;

      const updatedSubItem = { ...nextSubItemArray[subItemIndex] };
      const newBatches = [...(updatedSubItem.batch_data || [])];
      const batchIndex = newBatches.findIndex((b) => String(b.batch_id) === String(batchId));

      if (batchIndex > -1) {
        if (finalQty > 0) {
          newBatches[batchIndex] = { ...newBatches[batchIndex], quantity: finalQty };
        } else {
          newBatches.splice(batchIndex, 1);
        }
      } else if (finalQty > 0) {
        newBatches.push({
          batch_id: batchId,
          quantity: finalQty,
          batch_no: batch?.batch_no || batch?.batch_name || '-',
        });
      }

      updatedSubItem.batch_data = newBatches;
      nextSubItemArray[subItemIndex] = updatedSubItem;
      targetSaleItem.sub_item = nextSubItemArray;
      next[saleItemIndex] = targetSaleItem;

      setSubItemBatchPopup((prevPopup) => ({
        ...prevPopup,
        subItem: updatedSubItem,
      }));

      return next;
    });
  };

  const getItemRate = useCallback(
    (iRate = rate, iQty = quantity) => {
      return ShopsHelper.getAmountFormatted(shop, Number(iRate) * iQty);
    },
    [rate, quantity, shop]
  );

  const getTax = useCallback(
    (iRate = rate, iQty = quantity, iTax = item?.tax ?? 0) => {
      return ShopsHelper.getAmountFormatted(shop, (getItemRate(iRate, iQty) * iTax) / 100);
    },
    [item?.tax, getItemRate, quantity, rate, shop]
  );

  const getCess = useCallback(
    (iRate = rate, iQty = quantity, iCess = item?.cess ?? 0) => {
      return ShopsHelper.getAmountFormatted(shop, (getItemRate(Number(iRate), iQty) * iCess) / 100);
    },
    [item?.cess, getItemRate, quantity, rate, shop]
  );

  const handleChangePayable = (val) => {
    if (quantity === 0) return;
    if (item === null) {
      setRate(Number(val) / quantity);
      return;
    }
    const itemRate = (val - getTax(val)) / quantity;

    setRate(ShopsHelper.getAmountFormatted(shop, itemRate));
    setTax(ShopsHelper.getAmountFormatted(shop, getTax(itemRate)));
    setCess(ShopsHelper.getAmountFormatted(shop, getCess(itemRate)));
    setTotalAmount(ShopsHelper.getAmountFormatted(shop, val));
  };

  const handleChangeRate = (val) => {
    if (quantity === 0) return;
    if (item === null) {
      const value = Number(val);
      setRate(value);
      setTotalAmount(value * quantity);
      return;
    }
    const itemTax = getTax(val);
    const itemCess = getCess(val);
    const itemTotal = getItemRate(val) + itemTax + itemCess;

    setRate(ShopsHelper.getAmountFormatted(shop, val));
    setTax(ShopsHelper.getAmountFormatted(shop, itemTax));
    setCess(ShopsHelper.getAmountFormatted(shop, itemCess));
    setTotalAmount(ShopsHelper.getAmountFormatted(shop, itemTotal));
  };

  const handleChangeQty = (val) => {
    if (val === '') {
      setQuantity('');
      return;
    }
    let qty = Number(val);
    if (qty < 0) qty = 0;
    if (item === null) {
      setQuantity(qty);
      if (rate) {
        setTotalAmount(rate * qty);
      } else if (totalAmount) {
        setRate(totalAmount / qty);
      }
      return;
    }

    if (shop?.stock_availability_check_for_sale && item?.type !== 'COMBO') {
      const availableStock = getItemAvailableStock(item);
      if (qty > availableStock) {
        postAlertMessage({
          text: tOperations('Insufficient stock. Available stock is {{stock}}', { stock: availableStock }),
          type: 'failed',
        });
        qty = availableStock;
      }
    }

    let itemTax = getTax(rate, qty);
    let itemCess = getCess(rate, qty);
    setTax(itemTax);
    setCess(itemCess);
    setQuantity(qty);
    setTotalAmount(ShopsHelper.getAmountFormatted(shop, getItemRate(rate, qty) + itemTax + itemCess));
  };

  const handleChangeTax = (val) => {
    if (item === null) {
      const value = Number(val);
      setTax(value);
      setCess(0);
      setTotalAmount(quantity * rate + value);
    }
  };

  const handleFieldChange = (index, field, value) => {
    setSaleItems((prevItems) =>
      prevItems.map((item, i) => {
        if (index !== i) return item;

        if (field === 'description') {
          return { ...item, [field]: value };
        }

        if (field === 'salesperson_id') {
          return { ...item, [field]: Number(value) };
        }

        if (!item.item_id) {
          let valNum = Number(value);
          if (field === 'quantity' && valNum < 0) valNum = 0;
          const updatedItem = { ...item, [field]: valNum };
          if (['quantity', 'rate', 'tax'].includes(field)) {
            updatedItem.payable = updatedItem.quantity * updatedItem.rate + updatedItem.tax;
          } else if (field === 'payable') {
            updatedItem.rate = updatedItem.payable / updatedItem.quantity;
          }
          return updatedItem;
        }

        let qtyVal = field === 'quantity' ? Number(value) : item.quantity;
        if (field === 'quantity' && qtyVal < 0) qtyVal = 0;
        if (field === 'quantity' && shop?.stock_availability_check_for_sale && item.item && item.item.type !== 'COMBO') {
          const availableStock = getItemAvailableStock(item.item);
          let origQty = 0;
          if (editData && editData.items && item.id) {
            const origItem = editData.items.find((si) => String(si.id) === String(item.id));
            if (origItem) {
              origQty = Number(origItem.quantity || 0);
            }
          }
          const additionalQty = qtyVal - origQty;
          if (additionalQty > availableStock) {
            postAlertMessage({
              text: tOperations('Insufficient stock. Available stock is {{stock}}', { stock: availableStock }),
              type: 'failed',
            });
            qtyVal = availableStock + origQty;
          }
        }
        let sub_item = item.sub_item;
        if (field === 'quantity' && item.item?.type === 'COMBO' && item.sub_item) {
          sub_item = item.sub_item.map((si) => {
            const newRequiredQty = si.fraction * qtyVal;
            let selectedBatches = [];
            if (si.is_batch_enabled) {
              const currentWhId = warehouseId === 0 ? null : warehouseId;
              const availableBatches = (localBatches || stockBatches || [])
                .filter((b) => {
                  const isSameItem = String(b.item) === String(si.item_id);
                  if (!isSameItem) return false;

                  if (currentWhId) {
                    const bWhId = b.warehouse?.id || b.warehouse || null;
                    if (String(bWhId) !== String(currentWhId)) return false;
                  }

                  const expiryDate = b.expiry_date ? new Date(b.expiry_date.replace('Z', '')) : null;
                  const isExpired = expiryDate && expiryDate <= new Date();
                  return !isExpired;
                })
                .sort((a, b) => {
                  if (!a.expiry_date) return 1;
                  if (!b.expiry_date) return -1;
                  return new Date(a.expiry_date) - new Date(b.expiry_date);
                });

              let remainingToAllocate = newRequiredQty;
              for (const batch of availableBatches) {
                if (remainingToAllocate <= 0) break;
                const adjustedStock = (batch.stock || 0) + (originalBatchQtys[String(batch.id)] || 0);
                const take = Math.min(remainingToAllocate, adjustedStock);
                if (take > 0) {
                  selectedBatches.push({
                    batch_id: batch.id,
                    quantity: take,
                    batch_no: batch.batch_no || batch.batch_name,
                  });
                  remainingToAllocate -= take;
                }
              }
            }
            return {
              ...si,
              quantity: newRequiredQty,
              batch_data: selectedBatches,
            };
          });
        }

        const finalValue = field === 'quantity' ? qtyVal : Number(value);
        const updatedItem = {
          ...item,
          [field]: finalValue,
          tax: item?.item?.tax,
          cess: item?.item?.cess,
          sub_item,
        };
        if (field === 'payable' && updatedItem.quantity > 0) {
          updatedItem.rate = TaxManager.getItemUnitRateByPayable(updatedItem);
        }

        updatedItem.tax = TaxManager.getItemTax(updatedItem);
        updatedItem.cess = TaxManager.getItemCess(updatedItem);
        if (field !== 'payable') {
          updatedItem.payable = CartManager.getItemAmount(updatedItem) + updatedItem.tax + updatedItem.cess;
        }
        return updatedItem;
      })
    );
  };

  const handlePrint = async (saleIdOrInvoiceNo, size = PAPER_SIZE.A4, saleData = null) => {
    if (loadingIndicator) return;
    setLoadingIndicator(true);

    const isBackendFormat =
      shop?.web_invoice_format === INVOICE_LAYOUTS.A4_BACKEND ||
      shop?.web_invoice_format === INVOICE_LAYOUTS.A5_BACKEND;

    try {
      if (isBackendFormat) {
        let billNoToPrint = null;
        if (typeof saleIdOrInvoiceNo === 'string') {
          billNoToPrint = saleIdOrInvoiceNo;
        } else if (editData?.id === saleIdOrInvoiceNo) {
          billNoToPrint = editData.bill_no;
        } else {
          const sale = await SaleService.getSale(saleIdOrInvoiceNo);
          billNoToPrint = sale?.bill_no;
        }

        if (billNoToPrint) {
          const authToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
          const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);
          const url = `${BACKEND_URL}/reports/sales/details/pdf/?token=${authToken}&shop_id=${shopId}&bill_no=${billNoToPrint}`;
          window.open(url);
          setLoadingIndicator(false);
          return;
        }
      }

      const parsedSize =
        size === PAPER_SIZE.A4
          ? PAPER_SIZE.A4
          : size === PAPER_SIZE.A5_VERTICAL
          ? PAPER_SIZE.A5_VERTICAL
          : size === PAPER_SIZE.A5_HORIZONTAL
          ? PAPER_SIZE.A5_HORIZONTAL
          : PAPER_SIZE.THERMAL_80MM;
      setPaperSize(parsedSize);

      let fullSale =
        saleData || (editData?.id === saleIdOrInvoiceNo || editData?.bill_no === saleIdOrInvoiceNo ? editData : null);

      if (!fullSale) {
        if (
          typeof saleIdOrInvoiceNo === 'number' ||
          (typeof saleIdOrInvoiceNo === 'string' && !isNaN(saleIdOrInvoiceNo))
        ) {
          fullSale = await SaleService.getSale(saleIdOrInvoiceNo);
        } else {
          const sales = await SaleService.getSales({ search: saleIdOrInvoiceNo });
          if (sales && sales.length > 0) {
            fullSale = await SaleService.getSale(sales[0].id);
          }
        }
      }

      if (!fullSale) {
        postAlertMessage({ text: 'Sale not found', type: 'failed' });
        setLoadingIndicator(false);
        return;
      }

      const terminalId = fullSale.terminal?.id || fullSale.terminal_id || selectedTerminal?.id;
      let billFormat = null;
      if (terminalId) {
        billFormat = await getBillFormat(terminalId);
      } else if (terminals && terminals.length > 0) {
        billFormat = await getBillFormat(terminals[0].id);
      }

      if (
        shop?.web_invoice_format === INVOICE_LAYOUTS.A4_BACKEND ||
        shop?.web_invoice_format === INVOICE_LAYOUTS.A5_BACKEND ||
        !shop?.web_invoice_format
      ) {
        const authToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
        const shopId = localStorage.getItem(STORAGE_KEYS.SHOP_ID);
        let formatQuery = '';
        if (shop?.web_invoice_format === INVOICE_LAYOUTS.A4_BACKEND) formatQuery = '&invoice_format=a4';
        else if (shop?.web_invoice_format === INVOICE_LAYOUTS.A5_BACKEND) formatQuery = '&invoice_format=a5';
        const url = `${BACKEND_URL}/reports/sales/details/pdf/?token=${authToken}&shop_id=${shopId}&bill_no=${fullSale.bill_no}${formatQuery}`;
        window.open(url);
        return;
      }
      setSaleToPrint(fullSale);
      setBillFormatToPrint(billFormat);

      const totals = (fullSale.items || []).reduce(
        (acc, item) => {
          acc.payable += item.payable || 0;
          acc.tax += item.tax || 0;
          acc.cess += item.cess || 0;
          return acc;
        },
        { payable: 0, tax: 0, cess: 0 }
      );

      setTotalsToPrint(totals);
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    } finally {
      setLoadingIndicator(false);
    }
  };

  const billToPdf = async (saleIdOrBillNo) => {
    const targetSaleIdentifier =
      saleIdOrBillNo && typeof saleIdOrBillNo !== 'object'
        ? saleIdOrBillNo
        : editData?.id || billNo || `${invoiceNoPrefix}${invoiceNoSuffix}`;
    handlePrint(targetSaleIdentifier);
  };

  const filteredItemsList = useMemo(() => {
    return products || [];
  }, [products]);

  const filteredStockBatches = useMemo(() => {
    const currentWhId = warehouseId === 0 ? null : warehouseId;
    if (!currentWhId) return localBatches || [];
    return localBatches.filter((b) => {
      const bWhId = b.warehouse?.id || b.warehouse || null;
      return String(bWhId) === String(currentWhId);
    });
  }, [warehouseId, localBatches]);

  useEffect(() => {
    if (saleToPrint && billFormatToPrint && totalsToPrint) {
      const originalTitle = document.title;
      document.title = `${saleToPrint.bill_no || 'Invoice'}`;

      document.body.classList.add('printing-invoice');
      setTimeout(() => {
        window.print();
        document.body.classList.remove('printing-invoice');
        document.title = originalTitle;
        setSaleToPrint(null);
        setBillFormatToPrint(null);
        setTotalsToPrint(null);
      }, 500);
    }
  }, [saleToPrint, billFormatToPrint, totalsToPrint]);

  useEffect(() => {
    if (stockBatches && stockBatches.length > 0) {
      setLocalBatches((prev) => {
        const stockBatchesMap = new Map(stockBatches.map((b) => [String(b.id), b]));
        const updatedPrev = prev.map((b) => {
          const key = String(b.id);
          if (stockBatchesMap.has(key)) {
            return stockBatchesMap.get(key);
          }
          return b;
        });
        const prevIds = new Set(prev.map((b) => String(b.id)));
        const newBatches = stockBatches.filter((b) => !prevIds.has(String(b.id)));
        return [...updatedPrev, ...newBatches];
      });
    }
  }, [stockBatches]);

  useEffect(() => {
    if (selectedTerminal) {
      const prefix = selectedTerminal.invoice_no_prefix || '';
      setInvoiceNoPrefix(prefix);
      getNextinvoiceNo(prefix);
    }
  }, [selectedTerminal, getNextinvoiceNo]);

  useEffect(() => {
    if (saleItems.length > 0) {
      const updatedItems = CartManager.spreadAndSetBillLevelDiscount(saleItems, discountAppliedOnItems);
      setSaleItems(updatedItems);
    }
    //eslint-disable-next-line
  }, [discountAppliedOnItems]);

  useEffect(() => {
    const totals = saleItems.reduce(
      (acc, item) => {
        acc.payable += item.payable || 0;
        acc.tax += item.tax || 0;
        acc.cess += item.cess || 0;
        return acc;
      },
      { payable: 0, tax: 0, cess: 0 }
    );

    setSaleTotals(totals);
  }, [saleItems]);

  useEffect(() => {
    const loadData = async () => {
      setLoadingIndicator(true);
      try {
        const promises = [];
        if (!isMasterDataLoaded.current) {
          promises.push(fetchInitialData());
        }

        if (id) {
          promises.push(SaleService.getSale(id));
        }

        if (estimateIdParam) {
          promises.push(EstimateService.getEstimate(estimateIdParam));
        }

        const results = await Promise.all(promises);
        let resultIdx = 0;
        if (!isMasterDataLoaded.current) {
          resultIdx++; // fetchInitialData result is usually not used directly here
        }

        if (id) {
          const saleData = results[resultIdx++];
          handleSelectSaleClick(saleData);
        }

        if (estimateIdParam) {
          const estimateData = results[resultIdx++];
          setSelectedCustomer(estimateData?.customer);
          setSelectedWaiter(estimateData?.waiter || null);
          setRemark(estimateData.remark || '');
          setDiscountAppliedOnItems(estimateData.discount || 0);

          const processedEstimateItems = estimateData.items.map((ei) => {
            let updatedItem = ei?.item;
            if (updatedItem?.id) {
              const invItem = products.find((p) => p.id === updatedItem.id);
              if (invItem) {
                updatedItem = invItem;
              }
            }

            let sub_item = [];
            if (updatedItem?.type === 'COMBO') {
              let savedSubItemBatches = ei.sub_item_batch_data || ei.config?.sub_item_batch_data || [];
              if (savedSubItemBatches.length === 0) {
                const nestedSubItems = ei.sub_item || ei.config?.sub_item || [];
                nestedSubItems.forEach((subItemEntry) => {
                  if (subItemEntry.batch_data) {
                    subItemEntry.batch_data.forEach((b) => {
                      savedSubItemBatches.push({
                        item_id: subItemEntry.item_id,
                        batch_id: b.batch_id,
                        quantity: b.quantity,
                      });
                    });
                  }
                });
              }

              sub_item = (updatedItem.details?.sub_items || []).map((subItem) => {
                const prod = (products || []).find((p) => String(p.id) === String(subItem.item_id));
                const requiredQty = subItem.fraction * ei.quantity;

                const selectedBatches = savedSubItemBatches
                  .filter((sb) => String(sb.item_id) === String(subItem.item_id))
                  .map((sb) => {
                    const batch =
                      (localBatches || []).find((b) => String(b.id) === String(sb.batch_id)) ||
                      (stockBatches || []).find((b) => String(b.id) === String(sb.batch_id));
                    return {
                      batch_id: sb.batch_id,
                      quantity: sb.quantity,
                      batch_no: batch?.batch_no || batch?.batch_name || '-',
                    };
                  });

                return {
                  id: subItem.id,
                  item_id: subItem.item_id,
                  name: subItem.name || prod?.name || '-',
                  quantity: requiredQty,
                  fraction: subItem.fraction,
                  cost: prod?.cost || 0,
                  totalCost: requiredQty * (prod?.cost || 0),
                  is_batch_enabled: prod?.is_batch_enabled,
                  batch_data: selectedBatches,
                };
              });
            }

            return {
              ...ei,
              item: updatedItem,
              item_id: updatedItem?.id,
              name: updatedItem?.name,
              salesperson_id: ei?.salesperson?.id || ei?.waiter_id || null,
              batch_data: ei?.batch_data || [],
              sub_item,
            };
          });

          setSaleItems(processedEstimateItems);
        }

        isMasterDataLoaded.current = true;
      } catch (error) {
        postAlertMessage({ text: error.message, type: 'failed' });
      } finally {
        setLoadingIndicator(false);
      }
    };

    loadData();
    //eslint-disable-next-line
  }, [id]);

  const handleChangeTerminal = (event) => {
    const selectedId = event.target.value;
    const selected = terminals.find((t) => t.id === selectedId) || null;

    if (selected && selected.auth_token) {
      setDisabledTerminal(selected);
      return;
    }

    setSelectedTerminal(selected);

    if (selected && paymentModes === null) {
      getPaymentModes();
    }

    if (selected && selected?.invoice_no_prefix) {
      const terminalPrefix = selected.invoice_no_prefix;
      setInvoiceNoPrefix(terminalPrefix);
      getNextinvoiceNo(terminalPrefix);
    }
  };

  return (
    <>
      <div className={styles.contentWrapper}>
        <div className={styles.titleSec}>
          <h2 className={styles.title}>
            {tCommon('Sales')} <span className={styles.menuTitle}>{tCommon('Management')}</span>
          </h2>
        </div>
        <div className={styles.changeable}>
          <Grid container>
            <Grid item xs={12} sm={6}>
              <h2 className={styles.subTitle}>{editData.id ? tOperations('Edit Sale') : tOperations('New Sale')}</h2>
            </Grid>
            <Grid container item xs={12} sm={6}>
              {/* Print Button */}
              <Grid item xs={5} sm={4} className={styles.printIcon}>
                {editData?.id && (
                  <Tooltip title={tOperations('Print Invoice')}>
                    <IconButton disabled={(!invoiceNoSuffix && !billNo) || loadingIndicator} onClick={billToPdf}>
                      {loadingIndicator ? <CircularProgress size={20} /> : <PrintIcon />}
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>

              {/* Search Section */}
              <Grid item xs={7} sm={8} sx={{ position: 'relative' }}>
                <TextField
                  fullWidth
                  value={searchText}
                  onChange={(event) => setSearchText(event.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      handleSearchClick(event);
                    }
                  }}
                  placeholder={tOperations('Search invoice')}
                  variant="outlined"
                  size="small"
                  className={styles.searchInput}
                />

                {/* Search Icon Button inside input */}
                <Tooltip title={tCommon('Search')}>
                  <IconButton
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleSearchClick}
                    size='small'
                    sx={{
                      position: 'absolute',
                      right: 10,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: '#888',
                    }}>
                      <SearchIcon className={styles.searchIcon}/>
                    </IconButton>
                </Tooltip>

                {/* Dropdown Menu for invoice suggestions */}
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleSearchClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  {orders.map((sale) => (
                    <div key={sale.id || sale.bill_no}>
                      <MenuItem className={styles.menuList} onClick={() => handleSelectSaleClick(sale)}>
                        {`${sale.bill_no}${sale.customer ? ` - ${sale.customer.name}` : ''}`}
                      </MenuItem>
                      <Divider />
                    </div>
                  ))}
                </Menu>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={3} pt={2} alignItems="flex-start">
            {/* Column 1: Terminal and Salesperson */}
            <Grid item xs={12} md={4}>
              <Grid container direction="column" spacing={2}>
                {!editData.id && (
                  <Grid item>
                    <FormControl fullWidth size="small">
                      <InputLabel id="terminal-select-label">{tCommon('Terminal')}</InputLabel>
                      <Select
                        size="small"
                        labelId="terminal-select-label"
                        value={selectedTerminal?.id ?? ''}
                        onChange={handleChangeTerminal}
                        label={tCommon('Terminal')}
                        style={{
                          height: 42,
                        }}
                        renderValue={(value) => {
                          if (value === null) return tCommon('None');
                          const selected = terminals.find((t) => t.id === value);
                          return selected?.name || tCommon('None');
                        }}
                      >
                        <MenuItem value={null}>
                          <Typography>{tCommon('None')}</Typography>
                        </MenuItem>
                        {terminals.map((terminal) => (
                          <MenuItem
                            key={terminal.id}
                            value={terminal.id}
                            disabled={false}
                            style={{
                              color: terminal.auth_token ? 'gray' : 'inherit',
                              opacity: terminal.auth_token ? 0.6 : 1,
                            }}
                          >
                            {terminal.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                <Grid item>
                  <Autocomplete
                    value={selectedWaiter}
                    onChange={(event, newValue) => {
                      if (!newValue) {
                        setSelectedWaiter(null);
                      } else {
                        setSelectedWaiter(newValue || null);
                      }
                    }}
                    options={salespersons || []}
                    getOptionLabel={(option) => option.name || ''}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={tCommon('Salesperson')}
                        variant="outlined"
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: <>{params.InputProps.endAdornment}</>,
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        key={option.id}
                        style={{
                          paddingTop: '1px',
                          paddingBottom: '1px',
                        }}
                      >
                        {option.name}
                      </li>
                    )}
                    ListboxProps={{
                      style: { maxHeight: '200px' },
                    }}
                    freeSolo={false}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Column 2: Bill No and Date */}
            <Grid item xs={12} md={4}>
              <Grid container direction="column" spacing={2}>
                {!editData.id && selectedTerminal && (
                  <Grid item>
                    <TextField
                      fullWidth
                      id="demo-select-small-bill-no"
                      value={invoiceNoSuffix}
                      label={tOperations('Bill number')}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <span style={{ fontWeight: '500', color: '#666' }}>{invoiceNoPrefix}</span>
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => {
                        setInvoiceNoSuffix(e.target.value);
                      }}
                    />
                  </Grid>
                )}
                
                {editData?.id && (
                  <Grid item>
                    <TextField
                      fullWidth
                      id="demo-select-small-bill-no"
                      value={billNo}
                      label={tOperations('Bill number')}
                      variant="outlined"
                      size="small"
                      onChange={(e) => {
                        setBillNo(e.target.value);
                      }}
                    />
                  </Grid>
                )}
                <Grid item>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <DatePicker
                          value={billDate}
                          onChange={(date) => {
                            setBillDate(date);
                          }}
                          disableFuture
                          format="dd/MM/yyyy"
                          slotProps={{
                            textField: {
                              id: 'date-picker-from',
                              fullWidth: true,
                              className: styles.dateBox,
                              variant: 'outlined',
                              size: 'small',
                              InputProps: {
                                style: { paddingRight: 4 },
                              },
                            },
                            inputAdornment: {
                              sx: {
                                mr: 1,
                              },
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TimePicker
                          value={billDate}
                          onChange={(date) => {
                            setBillDate(date);
                          }}
                          slots={{
                            openPickerIcon: AccessTimeIcon,
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: 'small',
                              id: 'time-picker-from',
                              className: styles.dateBox,
                              variant: 'outlined',
                              InputProps: {
                                style: { paddingRight: 4 },
                              },
                            },
                            inputAdornment: {
                              sx: {
                                mr: 1,
                              },
                            },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </Grid>

            {/* Column 3: Warehouse and Customer */}
            <Grid item xs={12} md={4}>
              <Grid container direction="column" spacing={2}>
                {ShopsHelper.isWarehouseFeatureActive(shop) && (
                  <Grid item>
                    <TextField
                      select
                      name="warehouse_id"
                      size="small"
                      variant="outlined"
                      color="primary"
                      fullWidth
                      label={tCommon('Warehouse')}
                      value={warehouseId || 0}
                      disabled={!!editData.id}
                      onChange={(event) => {
                        const newWarehouseId = Number(event.target.value);
                        if (newWarehouseId !== warehouseId) {
                          setWarehouseId(newWarehouseId);
                          resetItemFields();
                          setSaleItems([]);
                          setOriginalBatchQtys({});
                          setDiscountAppliedOnItems(0);
                          setCustomerCreditUsed(0);
                          setLoyaltyPointsUsed(0);
                          setPaymentModes((prev) => {
                            if (prev) {
                              return prev.map((pm) => ({ ...pm, amount: 0 }));
                            }
                            return null;
                          });
                        }
                      }}
                    >
                      <MenuItem value={0}>{tCommon('None')}</MenuItem>
                      {warehouses?.map((warehouse) => (
                        <MenuItem key={warehouse.id} value={warehouse.id}>
                          {warehouse.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
                <Grid item>
                  <Autocomplete
                    value={customers.find((c) => c.id === selectedCustomer?.id) || null}
                    onChange={(event, newValue) => {
                      if (newValue?.id === 'create-new') {
                        openCreateNewCustomerDialog();
                      } else if (!newValue) {
                        setSelectedCustomer('');
                      } else {
                        setSelectedCustomer(newValue || '');
                      }
                    }}
                    options={[{ id: 'create-new', name: tCommon('Create New Customer') }, ...(customers || [])]}
                    getOptionLabel={(option) => option.name || ''}
                    filterOptions={(options, { inputValue }) => {
                      const cleanInput = inputValue.trim().toLowerCase();
                      return options.filter((option) => {
                        if (option.id === 'create-new') return true;
                        return (
                          (option.name && option.name.toLowerCase().includes(cleanInput)) ||
                          (option.mobile && option.mobile.toLowerCase().includes(cleanInput)) ||
                          (option.location && option.location.toLowerCase().includes(cleanInput)) ||
                          (option.code && option.code.toLowerCase().includes(cleanInput))
                        );
                      });
                    }}
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      if (option.id === 'create-new') {
                        return (
                          <MenuItem
                            key={option.id || key}
                            {...optionProps}
                            className={styles.createNewOption}
                          >
                            <AddCircleOutlineIcon className={styles.createNewOptionIcon} style={{ marginRight: 8 }} />
                            {option.name}
                          </MenuItem>
                        );
                      }
                      return (
                        <MenuItem
                          key={option.id || key}
                          {...optionProps}
                          className={styles.dropdownOption}
                        >
                          {option.name}
                        </MenuItem>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={tCommon('Customer')}
                        variant="outlined"
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: <>{params.InputProps.endAdornment}</>,
                        }}
                        helperText={
                          selectedCustomer && (
                            <>
                              <span>
                                {tCommon('Location')}: {selectedCustomer.location}, {tOperations('Phone')}:{' '}
                                {selectedCustomer.mobile}
                              </span>
                              <br />
                              <span>
                                {tOperations('Credit Limit')}:
                                {selectedCustomer.credit_limit < 0
                                  ? ` (Cr) ${Math.abs(selectedCustomer.credit_limit)}`
                                  : selectedCustomer.credit_limit}
                                , {tCommon('Balance')}:{' '}
                                {selectedCustomer.balance < 0
                                  ? ` (C)r ${Math.abs(selectedCustomer.balance)}`
                                  : selectedCustomer.balance}
                                , {tCommon('points')}: {selectedCustomer.points || 0}
                              </span>
                            </>
                          )
                        }
                      />
                    )}
                    ListboxProps={{
                      style: { maxHeight: '200px' },
                    }}
                    freeSolo={false}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <div className={styles.changeable} style={{ boxShadow: 'none', padding: '0', overflowX: 'auto' }}>
          <TableRow key="input row">
            <TableCell>
              <Autocomplete
                value={item}
                onChange={(event, newValue) => {
                  if (!newValue) {
                    resetItemFields(null);
                  } else {
                    selectItemHandler(newValue || null);
                  }
                }}
                inputValue={itemName}
                onInputChange={(e, value) => {
                  setItemName(value);
                }}
                getOptionLabel={(option) => `${option?.name}`}
                options={filteredItemsList}
                ListboxProps={{
                  sx: {
                    overflowX: 'auto',
                    whiteSpace: 'nowrap',
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={tCommon('Product')}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: <>{params.InputProps.endAdornment}</>,
                    }}
                  />
                )}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <MenuItem
                      key={key}
                      {...optionProps}
                      style={{
                        paddingTop: '1px',
                        paddingBottom: '1px',
                      }}
                    >
                      {option.name}
                    </MenuItem>
                  );
                }}
                freeSolo={false}
                style={{ minWidth: '250px' }}
              />
            </TableCell>

            <TableCell>
              <TextField
                label={tCommon('Stock')}
                variant="outlined"
                size="small"
                fullWidth
                value={stock}
                disabled
                type="text"
                style={{ minWidth: '30px' }}
              />
            </TableCell>
            <TableCell>
              <NumberField
                label={tCommon('Rate')}
                value={rate}
                onChange={(e) => handleChangeRate(e.target.value)}
                style={{ minWidth: '60px' }}
              />
            </TableCell>
            <TableCell>
              {item?.is_batch_enabled ? (
                <NumberField
                  type="text"
                  label={tCommon('Quantity')}
                  value={quantity}
                  onChange={(e) => handleChangeQty(e.target.value)}
                  style={{ minWidth: '100px', cursor: 'pointer' }}
                  sx={{ '& input': { cursor: 'pointer' } }}
                  inputProps={{ readOnly: true }}
                  onKeyDown={(e) => e.preventDefault()}
                  InputProps={{
                    onClick: (e) => {
                      setBatchPopupAnchor(e.currentTarget);
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <MuiIconButton color="primary" size="small">
                          <ArrowDropDownIcon fontSize="small" />
                        </MuiIconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              ) : (
                <NumberField
                  label={tCommon('Quantity')}
                  value={quantity}
                  onChange={(e) => handleChangeQty(e.target.value)}
                  style={{ minWidth: '40px' }}
                />
              )}
            </TableCell>
            <TableCell>
              <NumberField
                label={tCommon('Tax')}
                disabled={item}
                value={Number(tax) + Number(cess) || 0}
                onChange={(e) => handleChangeTax(e.target.value)}
                style={{ minWidth: '60px' }}
              />
            </TableCell>
            <TableCell>
              <NumberField
                label={tCommon('Payable')}
                value={totalAmount}
                onChange={(e) => handleChangePayable(e.target.value)}
                style={{ minWidth: '60px' }}
              />
            </TableCell>
            <TableCell>
              <Autocomplete
                value={salespersons.find((s) => s.id === selectedSalespersonId) || null}
                onChange={(event, newItem) => {
                  setSelectedSalespersonId(newItem.id || null);
                }}
                disableClearable
                onInputChange={(e, value) => {
                  setSelectedSalespersonId(value.id || null);
                }}
                getOptionLabel={(option) => `${option?.name}`}
                options={salespersons || []}
                renderInput={(params) => (
                  <TextField {...params} label={tOperations('Assignee')} variant="outlined" size="small" />
                )}
                style={{ minWidth: '120px' }}
              />
            </TableCell>

            <TableCell>
              <IconButton
                disabled={Number(quantity) <= 0 || rate === ''}
                onClick={addItem}
              >
                <AddIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        </div>
        <TableContainer style={{ marginTop: 4 }} component={Paper}>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell style={{ minWidth: '200px' }} className={styles.nameColumn}>
                  {tCommon('Product')}
                </TableCell>

                <TableCell style={{ minWidth: '75px' }} className={styles.columnCell}>
                  {tCommon('Rate')}
                </TableCell>
                <TableCell style={{ minWidth: '65px' }} className={styles.columnCell}>
                  {tCommon('Quantity')}
                </TableCell>
                <TableCell style={{ minWidth: '75px' }} className={styles.columnCell}>
                  {tCommon('Total Tax')}
                </TableCell>
                <TableCell style={{ minWidth: '75px' }} className={styles.columnCell}>
                  {tCommon('Total')}
                </TableCell>
                <TableCell style={{ minWidth: '150px' }} className={styles.columnCell}>
                  {tOperations('Assignee')}
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {saleItems &&
                saleItems.map((saleItem, index) => (
                  <SaleItemRow
                    key={saleItem?.item_id || index}
                    saleItem={saleItem}
                    index={index}
                    dltItem={dltItem}
                    handleFieldChange={handleFieldChange}
                    salespersons={salespersons}
                    shop={shop}
                    tCommon={tCommon}
                    tOperations={tOperations}
                    localBatches={localBatches}
                    originalBatchQtys={originalBatchQtys}
                    handleOpenSubItemBatchPopup={handleOpenSubItemBatchPopup}
                    setEditingTableItemIndex={setEditingTableItemIndex}
                    setBatchPopupAnchor={setBatchPopupAnchor}
                  />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        {!editData?.id && (
          <div className={styles.changeable} style={{ marginTop: 12 }}>
            <h3 className={styles.subTitle} style={{ marginBottom: 16 }}>
              {tOperations('Payment Information')}
            </h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: 8 }}>
              {(paymentModes || []).map((pm) => (
                <div key={pm.mode_id} style={{ display: 'flex', flexDirection: 'column', width: '220px' }}>
                  <NumberField
                    label={pm.name}
                    value={pm.amount || ''}
                    onChange={(e) => {
                      const updatedAmount = Number(e.target.value);
                      setPaymentModes((prev) =>
                        prev.map((item) =>
                          item.mode_id === pm.mode_id ? { ...item, amount: updatedAmount } : item
                        )
                      );
                    }}
                  />
                  <Button
                    size="small"
                    variant="text"
                    color="primary"
                    className={styles.payFullBtn}
                    style={{ textTransform: 'none', fontSize: '0.75rem', alignSelf: 'flex-end', marginTop: '2px', padding: 0 }}
                    title={tOperations('Pay Full')}
                    onClick={() => {
                      const rawPayable = Number(saleTotals?.payable) + Number(totalAmount);
                      const payableAmount = Number(rawPayable.toFixed(3));
                      setPaymentModes((prev) =>
                        prev.map((item) =>
                          item.mode_id === pm.mode_id
                            ? { ...item, amount: payableAmount }
                            : { ...item, amount: 0 }
                        )
                      );
                      setCustomerCreditUsed(0);
                      setLoyaltyPointsUsed(0);
                    }}
                  >
                    {tOperations('Payment In Full')}
                  </Button>
                </div>
              ))}
              {selectedCustomer && (
                <div style={{ display: 'flex', flexDirection: 'column', width: '220px' }}>
                  <NumberField
                    label={tOperations('Credit')}
                    value={customerCreditUsed || ''}
                    onChange={(e) => {
                      setCustomerCreditUsed(Number(e.target.value));
                    }}
                  />
                </div>
              )}
              {selectedCustomer && selectedCustomer.enable_loyalty_points && (
                <div style={{ display: 'flex', flexDirection: 'column', width: '220px' }}>
                  <NumberField
                    label={tOperations('points')}
                    value={loyaltyPointsUsed || ''}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      setLoyaltyPointsUsed(val);
                      if (selectedCustomer && val > selectedCustomer.points) {
                        postAlertMessage({
                          text: tOperations('insufficient_loyalty_point'),
                          type: 'failed',
                        });
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        <TableContainer style={{ marginTop: 12 }} component={Paper}>
          <Table aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell rowSpan={6} style={{ width: '50%' }}>
                  <TextField
                    id="outlined-multiline-static"
                    label={tOperations('Remark')}
                    multiline
                    rows={12}
                    value={remark}
                    variant="outlined"
                    fullWidth
                    onChange={(event) => setRemark(event.target.value)}
                  />
                </TableCell>
                <TableCell>{tCommon('Total Amount')}</TableCell>
                <TableCell colSpan={2} align="right" style={{ fontWeight: 600 }}>
                  {ShopsHelper.getAmountFormatted(
                    shop,
                    Number(saleTotals?.payable) +
                      Number(totalAmount) +
                      Number(discountAppliedOnItems) -
                      (Number(saleTotals?.tax) + Number(saleTotals?.cess) + Number(tax) + Number(cess))
                  )}
                </TableCell>
              </TableRow>
              {shop?.tax_region === COUNTRY_CONFIGRATION.IN.name ? (
                <>
                  <TableRow>
                    <TableCell>CGST</TableCell>
                    <TableCell colSpan={2} align="right" style={{ fontWeight: 600 }}>
                      {ShopsHelper.getAmountFormatted(
                        shop,
                        (Number(saleTotals?.tax) + Number(saleTotals?.cess) + Number(tax) + Number(cess)) / 2
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>SGST</TableCell>
                    <TableCell colSpan={2} align="right" style={{ fontWeight: 600 }}>
                      {ShopsHelper.getAmountFormatted(
                        shop,
                        (Number(saleTotals?.tax) + Number(saleTotals?.cess) + Number(tax) + Number(cess)) / 2
                      )}
                    </TableCell>
                  </TableRow>
                </>
              ) : (
                <TableRow>
                  <TableCell>{tCommon('Total Tax')}</TableCell>
                  <TableCell colSpan={2} align="right" style={{ fontWeight: 600 }}>
                    {ShopsHelper.getAmountFormatted(
                      shop,
                      Number(saleTotals?.tax) + Number(saleTotals?.cess) + Number(tax) + Number(cess)
                    )}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell>{tCommon('Discount')}</TableCell>
                <TableCell colSpan={2} align="right">
                  <TextField
                    fullWidth
                    id="demo-select-small"
                    value={discountAppliedOnItems}
                    label={tCommon('Discount')}
                    variant="outlined"
                    size="small"
                    onChange={(event) => setDiscountAppliedOnItems(Number(event.target.value))}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{tCommon('Payable')}</TableCell>
                <TableCell colSpan={2} align="right" style={{ fontWeight: 600 }}>
                  {ShopsHelper.getAmountFormatted(shop, Number(saleTotals?.payable) + Number(totalAmount))}
                </TableCell>
              </TableRow>
              {!editData?.id &&
                (() => {
                  const conversionRate = Number(shop?.loyalty_point_conversion_rate || 1);
                  const totalTendered =
                    (paymentModes || []).reduce((sum, mode) => sum + Number(mode.amount || 0), 0) +
                    customerCreditUsed +
                    loyaltyPointsUsed * conversionRate;
                  const payableAmount = Number(saleTotals?.payable) + Number(totalAmount);
                  const mismatch = payableAmount - totalTendered;

                  return (
                    <>
                      <TableRow>
                        <TableCell>{tOperations('Tendered')}</TableCell>
                        <TableCell colSpan={2} align="right" style={{ fontWeight: 600 }}>
                          {ShopsHelper.getAmountFormatted(shop, totalTendered)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ color: 'red' }}>{tOperations('Due')}</TableCell>
                        <TableCell colSpan={2} align="right" style={{ fontWeight: 600, color: 'red' }}>
                          {ShopsHelper.getAmountFormatted(shop, mismatch)}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })()}
            </TableHead>
          </Table>
        </TableContainer>
        <Grid container className={styles.submitSection} justify="flex-end">
          <Button variant="contained" color="secondary" className={styles.closeBtn} onClick={clearSaleHandler}>
            {tCommon('Cancel')}
          </Button>
          {!editData.id && (
            <Button
              variant="contained"
              color="primary"
              style={{ backgroundColor: '#00a65a', marginRight: '8px' }}
              disabled={billDate === '' || loadingIndicator}
              onClick={() => {
                handleAddSale(SALE_STATUS.draft);
              }}
            >
              {tCommon('Save as Draft')}
            </Button>
          )}
          {!editData.id && (
            <Button
              variant="contained"
              color="primary"
              style={{ backgroundColor: '#00a65a' }}
              disabled={billDate === '' || loadingIndicator}
              onClick={() => {
                handleAddSale(SALE_STATUS.active);
              }}
            >
              {tOperations('Save Sale')}
            </Button>
          )}
          {editData.id && editData.status === SALE_STATUS.draft && (
            <>
              <Button
                variant="contained"
                color="primary"
                style={{ backgroundColor: '#00a65a', marginRight: '8px' }}
                disabled={billDate === '' || loadingIndicator}
                onClick={() => {
                  handleSaleEditHandler(SALE_STATUS.draft);
                }}
              >
                {tCommon('Update as draft')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ backgroundColor: '#00a65a' }}
                disabled={billDate === '' || loadingIndicator}
                onClick={() => {
                  handleSaleEditHandler(SALE_STATUS.active);
                }}
              >
                {tCommon('Update as Sale')}
              </Button>
            </>
          )}
          {editData.id && (editData.status === SALE_STATUS.active || editData.status === SALE_STATUS.paid) && (
            <Button
              variant="contained"
              color="primary"
              style={{ backgroundColor: '#00a65a' }}
              disabled={billDate === '' || loadingIndicator}
              onClick={() => {
                handleSaleEditHandler(SALE_STATUS.active);
              }}
            >
              {tOperations('Update Sale')}
            </Button>
          )}
        </Grid>
      </div>
      {isShowRefudnTypePopup && (
        <RefundTypePopup
          closeDialog={handleCloseRefundTypePopup}
          handleRefundType={(type) => {
            handleEditSale(saleStatus, type);
          }}
          subject={'sale'}
        />
      )}
      <MessagePopup
        data={disabledTerminal}
        handleClose={() => setDisabledTerminal(null)}
        alertTitle={tOperations('Terminal Disabled')}
        alertContent={tOperations(
          'This terminal is currently in use on a POS device. Please select another terminal, log out from the POS to use this terminal, or proceed with creating the sale without selecting a terminal.'
        )}
        successBtnName={tOperations('Okay')}
      />
      {updateSuccessData && (
        <SalesUpdateSuccessDialog
          handleClose={() => setUpdateSuccessData(null)}
          data={updateSuccessData}
        />
      )}
      {isShowNewCustomerDialog && (
        <NewCustomerDialog
          closeCreateNewCustomerDialog={closeCreateNewCustomerDialog}
          reloadCustomers={getCustomers}
          customerGroups={customerGroups}
        />
      )}
      {saleToPrint &&
        createPortal(
          <PrintDocument
            type={PRINT_TYPES.SALE}
            data={saleToPrint}
            shop={shop}
            billFormat={billFormatToPrint}
            totals={totalsToPrint}
            paperSize={paperSize}
          />,
          document.body
        )}
      <BatchSelectionPopup
        open={subItemBatchPopup.open}
        anchorEl={subItemBatchPopup.anchorEl}
        onClose={() => setSubItemBatchPopup({ ...subItemBatchPopup, open: false })}
        item={subItemBatchPopup.item}
        stockBatches={filteredStockBatches}
        selectedBatches={subItemBatchPopup.subItem?.batch_data || []}
        originalBatchQtys={originalBatchQtys}
        onChange={handleSubItemBatchChange}
        showExpired={false}
      />
      <BatchSelectionPopup
        open={Boolean(batchPopupAnchor)}
        anchorEl={batchPopupAnchor}
        onClose={() => {
          setBatchPopupAnchor(null);
          setEditingTableItemIndex(null);
        }}
        item={editingTableItemIndex !== null ? saleItems[editingTableItemIndex]?.item : item}
        stockBatches={filteredStockBatches}
        selectedBatches={
          editingTableItemIndex !== null
            ? saleItems[editingTableItemIndex]?.batch_data || []
            : selectedItemBatches
        }
        originalBatchQtys={originalBatchQtys}
        onChange={handleBatchQuantityChange}
        showExpired={false}
      />
    </>
  );
}

function SaleItemRow({
  saleItem,
  index,
  dltItem,
  handleFieldChange,
  salespersons,
  shop,
  tCommon,
  tOperations,
  localBatches,
  originalBatchQtys,
  handleOpenSubItemBatchPopup,
  setEditingTableItemIndex,
  setBatchPopupAnchor,
}) {
  const [open, setOpen] = useState(true);
  const [isEditingDescription, setIsEditingDescription] = useState(false);

  return (
    <>
      <TableRow>
        <TableCell>
          {!saleItem.item ? (
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              placeholder={tCommon('Description')}
              value={saleItem.description || ''}
              onChange={(e) => handleFieldChange(index, 'description', e.target.value)}
            />
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {saleItem.item?.type === 'COMBO' && (
                  <IconButton size="small" onClick={() => setOpen(!open)} style={{ marginRight: 4 }}>
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  </IconButton>
                )}
                <span>{saleItem?.name || saleItem.item?.name}</span>
              </div>
              <div style={{ marginTop: '4px', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                {isEditingDescription ? (
                  <>
                    <TextField
                      size="small"
                      variant="outlined"
                      value={saleItem.description || ''}
                      onChange={(e) => handleFieldChange(index, 'description', e.target.value)}
                      placeholder={tCommon('Description')}
                      style={{ minWidth: '150px' }}
                      autoFocus
                    />
                    <IconButton size="small" onClick={() => setIsEditingDescription(false)}>
                      <CheckIcon fontSize="small" style={{ fontSize: '0.85rem' }} />
                    </IconButton>
                  </>
                ) : (
                  <>
                    {saleItem.description ? (
                      <span style={{ fontSize: '0.8rem', color: '#555', flex: 1 }}>
                        {saleItem.description}
                      </span>
                    ) : (
                      <span style={{ fontSize: '0.8rem', color: '#999', fontStyle: 'italic', flex: 1 }}>
                        {tCommon('No description')}
                      </span>
                    )}
                    <IconButton
                      size="small"
                      style={{ padding: '2px', marginTop: '-2px', alignSelf: 'flex-start' }}
                      onClick={() => setIsEditingDescription(true)}
                    >
                      <EditIcon style={{ fontSize: '0.85rem' }} />
                    </IconButton>
                  </>
                )}
              </div>
              {saleItem.batch_data && saleItem.batch_data.length > 0 && (
                <div style={{ fontSize: '0.8rem', color: '#666', marginTop: '4px' }}>
                  {saleItem.batch_data.map((sb, idx) => {
                    const batch = (localBatches || []).find((b) => String(b.id) === String(sb.batch_id));
                    return (
                      <div key={sb.batch_id}>
                        {batch?.batch_name || batch?.batch_no || sb.batch_id}: {sb.quantity}
                        {idx < saleItem.batch_data.length - 1 ? ', ' : ''}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </TableCell>
        <TableCell>
          <NumberField
            value={saleItem.rate === 0 ? '' : ShopsHelper.getAmountFormatted(shop, Number(saleItem.rate))}
            onChange={(e) => handleFieldChange(index, 'rate', e.target.value)}
          />
        </TableCell>
        <TableCell>
          {saleItem?.item?.is_batch_enabled ? (
            <NumberField
              type="text"
              value={saleItem.quantity === 0 ? '' : saleItem.quantity}
              style={{ cursor: 'pointer' }}
              sx={{ '& input': { cursor: 'pointer' } }}
              inputProps={{ readOnly: true }}
              onKeyDown={(e) => e.preventDefault()}
              InputProps={{
                onClick: (e) => {
                  setEditingTableItemIndex(index);
                  setBatchPopupAnchor(e.currentTarget);
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <MuiIconButton color="primary" size="small">
                      <ArrowDropDownIcon fontSize="small" />
                    </MuiIconButton>
                  </InputAdornment>
                ),
              }}
            />
          ) : (
            <NumberField
              value={saleItem.quantity === 0 ? '' : saleItem.quantity}
              onChange={(e) => handleFieldChange(index, 'quantity', e.target.value)}
            />
          )}
        </TableCell>
        <TableCell>
          <NumberField
            value={ShopsHelper.getAmountFormatted(shop, Number(saleItem.tax) + Number(saleItem.cess) || 0)}
            onChange={(e) => handleFieldChange(index, 'tax', e.target.value)}
          />
        </TableCell>
        <TableCell>
          <NumberField
            value={saleItem.payable ? ShopsHelper.getAmountFormatted(shop, saleItem.payable) : '0.00'}
            onChange={(e) => handleFieldChange(index, 'payable', e.target.value)}
          />
        </TableCell>
        <TableCell>
          <Autocomplete
            value={salespersons.find((s) => s.id === (saleItem?.salesperson_id || saleItem?.salesperson)) || null}
            onChange={(event, newValue) => {
              handleFieldChange(index, 'salesperson_id', newValue ? newValue.id : null);
            }}
            disableClearable
            getOptionLabel={(option) => `${option?.name}`}
            options={salespersons || []}
            renderInput={(params) => (
              <TextField {...params} label={tOperations('Assignee')} variant="outlined" size="small" />
            )}
            style={{ minWidth: '75px', width: '180px' }}
          />
        </TableCell>

        <TableCell>
          <IconButton onClick={() => dltItem(saleItem)}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      {saleItem.item?.type === 'COMBO' && (
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Typography variant="h6" gutterBottom component="div" style={{ fontSize: '0.9rem', fontWeight: 600 }}>
                  {tCommon('Sub Items')}
                </Typography>
                <Table size="small" aria-label="sub-items">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 600 }}>{tCommon('Name')}</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>{tCommon('Required Qty')}</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>{tCommon('Selected Batches')}</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>{tCommon('Remaining Qty')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(saleItem.sub_item || []).map((si) => {
                      const totalSelected = (si.batch_data || []).reduce((sum, b) => sum + (b.quantity || 0), 0);
                      const remaining = Math.max(0, si.quantity - totalSelected);
                      return (
                        <TableRow key={si.item_id}>
                          <TableCell>
                            {si.name}
                            {si.is_batch_enabled && si.batch_data && si.batch_data.length > 0 && (
                              <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                {si.batch_data.map((sb, idx) => {
                                  const batch = (localBatches || []).find((b) => String(b.id) === String(sb.batch_id));
                                  return (
                                    <span key={sb.batch_id}>
                                      {batch?.batch_name || batch?.batch_no || sb.batch_id}: {sb.quantity.toFixed(3)}
                                      {idx < si.batch_data.length - 1 ? ', ' : ''}
                                    </span>
                                  );
                                })}
                              </div>
                            )}
                          </TableCell>
                          <TableCell>{si.quantity.toFixed(3)}</TableCell>
                          <TableCell>
                            {si.is_batch_enabled ? (
                              <NumberField
                                value={totalSelected === 0 ? '' : totalSelected}
                                style={{ minWidth: '100px', cursor: 'pointer' }}
                                sx={{ '& input': { cursor: 'pointer' } }}
                                inputProps={{ readOnly: true }}
                                onKeyDown={(e) => e.preventDefault()}
                                InputProps={{
                                  onClick: (e) => {
                                    handleOpenSubItemBatchPopup(e, index, si);
                                  },
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <MuiIconButton color="primary" size="small">
                                        <ArrowDropDownIcon fontSize="small" />
                                      </MuiIconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            ) : (
                              '-'
                            )}
                          </TableCell>
                          <TableCell style={{ color: Math.abs(remaining) > 0.001 ? 'red' : 'inherit' }}>
                            {si.is_batch_enabled ? remaining.toFixed(3) : '-'}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}

export default withConsoleBase(AddSales);
